<template>
    <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
        <span class="vx-col mt-2">Số phần tử / trang:</span>
        <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                <span class="mr-2">
                    <!-- {{ itemList.length > 0 ? currentPage * paginationPageSize - (paginationPageSize - 1) : 0 }} - -->
                    {{ itemList.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : itemList.length }} /
                    {{ itemList.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

                <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                    <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(15)">
                    <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                    <span>20</span>
                </vs-dropdown-item>
                <!-- <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                    <span>100</span>
                </vs-dropdown-item> -->
            </vs-dropdown-menu>
        </vs-dropdown>
    </div>
</template>

<script>
export default {
    props: ['itemList', 'currentPage', 'paginationPageSize', 'gridApi'],
    created: function () {
    },
    computed: {}


}
</script>
<style scoped>
.p-4 {
    padding: 0.75rem !important;
}

.rounded-full {
    border-radius: 5px !important;
}
</style>
